import React from 'react';

import { TextField } from '@mui/material';

import {
  type AnyItem,
  type EditableItem,
  getDescriptionLabel,
  getDescriptionValue,
  isDescriptionEditable,
  setDescriptionValue,
} from './atolEditHelpers';

interface AtolDescriptionFieldEditorProps {
  editItem: EditableItem;
  isLoading: boolean;
  onUpdateField: (itemId: string, updater: (current: AnyItem) => AnyItem) => void;
}

export default function AtolDescriptionFieldEditor({
  editItem,
  isLoading,
  onUpdateField,
}: AtolDescriptionFieldEditorProps) {
  const { groupKey, current } = editItem;

  if (!isDescriptionEditable(groupKey)) {
    return null;
  }

  const value = getDescriptionValue(groupKey, current);
  const label = getDescriptionLabel(groupKey);

  return (
    <TextField
      label={label}
      value={value}
      onChange={(e) => {
        const newValue = e.target.value;
        onUpdateField(current.id, (currentItem) => setDescriptionValue(groupKey, currentItem, newValue));
      }}
      fullWidth
      disabled={isLoading}
    />
  );
}
